/**
 * Empty comparator.
 * @function
 * @return {Number} Always 0 (means equals).
 * */
export const emptyComparator = () => {
    return 0;
};
